import { vehiclesApi } from '@repo/api'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

export const useTrailersPaginated = (params: {
  page: number
  pageSize: number
  search?: string
}) => {
  return useQuery({
    queryKey: ['vehicles', 'trailers', 'paginated', params],
    queryFn: () => vehiclesApi.getTrailersPaginated(params),
    placeholderData: keepPreviousData,
  })
}
